'use client';

import * as React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { cn } from '@/lib/utils';

const MHSelect = Select;

const MHSelectTrigger = React.forwardRef<
  React.ElementRef<typeof SelectTrigger>,
  React.ComponentPropsWithoutRef<typeof SelectTrigger>
>(({ className, ...props }, ref) => (
  <SelectTrigger
    ref={ref}
    className={cn(
      'flex h-11 w-full items-center justify-between rounded-full bg-surface-2 px-4 text-body text-text-primary',
      'placeholder:text-text-tertiary',
      'focus-visible:outline-none focus-visible:[box-shadow:var(--mh-focus-ring)] focus-visible:ring-offset-0',
      'disabled:cursor-not-allowed disabled:opacity-50',
      className
    )}
    {...props}
  />
));
MHSelectTrigger.displayName = 'MHSelectTrigger';

const MHSelectContent = React.forwardRef<
  React.ElementRef<typeof SelectContent>,
  React.ComponentPropsWithoutRef<typeof SelectContent>
>(({ className, ...props }, ref) => (
  <SelectContent
    ref={ref}
    className={cn('rounded-[18px] bg-surface-3 text-text-primary shadow-popover', className)}
    {...props}
  />
));
MHSelectContent.displayName = 'MHSelectContent';

const MHSelectItem = React.forwardRef<
  React.ElementRef<typeof SelectItem>,
  React.ComponentPropsWithoutRef<typeof SelectItem>
>(({ className, ...props }, ref) => (
  <SelectItem
    ref={ref}
    className={cn(
      'text-body text-text-primary focus:bg-surface-2 focus:text-text-primary',
      className
    )}
    {...props}
  />
));
MHSelectItem.displayName = 'MHSelectItem';

const MHSelectValue = SelectValue;

export {
  MHSelect,
  MHSelectTrigger,
  MHSelectContent,
  MHSelectItem,
  MHSelectValue,
};
